import { lazy } from 'react';

import { RouteObject } from '@/types/router';

import { LazyLoad } from '../utils/lazy-load';

export default [
  {
    path: '/purse',
    children: [
      {
        path: 'exchange',
        children: [
          {
            path: 'bean',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/exchange/bean'))),
              },
            ],
          },
          {
            path: 'coffee',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/exchange/coffee'))),
              },
            ],
          },
          {
            path: 'pearl',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/exchange/pearl'))),
              },
            ],
          },
          {
            path: 'result',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/exchange/result'))),
              },
            ],
          },
        ],
      },
      {
        path: 'transfer',
        children: [
          {
            path: 'pearl',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/transfer/pearl'))),
              },
            ],
          },
          {
            path: 'result',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/transfer/result'))),
              },
            ],
          },
        ],
      },
      {
        path: 'withdraw',
        children: [
          {
            path: 'pearl',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/withdraw/pearl'))),
              },
            ],
          },
          {
            path: 'information',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/withdraw/information'))),
              },
            ],
          },
          {
            path: 'result',
            children: [
              {
                index: true,
                element: LazyLoad(lazy(() => import('@/pages/purse/withdraw/result'))),
              },
            ],
          },
        ],
      },
      {
        path: 'sell',
        children: [
          {
            index: true,
            element: LazyLoad(lazy(() => import('@/pages/purse/sell/home'))),
          },
          {
            path: 'details',
            element: LazyLoad(lazy(() => import('@/pages/purse/sell/details'))),
          },
          {
            path: 'dialog',
            children: [
              {
                path: 'coin',
                element: LazyLoad(lazy(() => import('@/pages/purse/sell/dialog/coin'))),
              },
              {
                path: 'pearl',
                element: LazyLoad(lazy(() => import('@/pages/purse/sell/dialog/pearl'))),
              },
            ],
          },
        ],
      },
    ],
  },
] as RouteObject[];
